import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { Helmet } from 'react-helmet';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { resetPassword } from '../services/authService';
import { getErrorMessage } from '../utils/errorHandler';
import data from '../data/paomakeup';

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') || '';
  const emailParam = searchParams.get('email') || '';

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertVariant, setAlertVariant] = useState('danger');
  const [showAlert, setShowAlert] = useState(false);

  const { register, handleSubmit, formState: { errors }, watch } = useForm({
    defaultValues: { email: emailParam },
  });
  const password = watch('password');

  const onSubmit = async (formData) => {
    try {
      setIsSubmitting(true);
      setShowAlert(false);
      await resetPassword({
        token,
        email: formData.email,
        password: formData.password,
        password_confirmation: formData.password_confirmation,
      });
      setAlertVariant('success');
      setAlertMessage('Su contrasena ha sido restablecida correctamente. Puede iniciar sesion.');
      setShowAlert(true);
      setTimeout(() => navigate('/iniciar-sesion'), 3000);
    } catch (err) {
      setAlertVariant('danger');
      setAlertMessage(getErrorMessage(err));
      setShowAlert(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container className="my-5">
      <Helmet>
        <title>Restablecer Contrasena - {data.title}</title>
      </Helmet>
      <Row className="justify-content-center">
        <Col sm={8} md={6} lg={5}>
          <h1 className="mb-4 text-center">Restablecer Contrasena</h1>

          {showAlert && (
            <Alert variant={alertVariant} onClose={() => setShowAlert(false)} dismissible>
              {alertMessage}
            </Alert>
          )}

          <Form className="auth-form" onSubmit={handleSubmit(onSubmit)}>
            <Form.Group className="mb-3" controlId="resetEmail">
              <Form.Label>Correo electronico</Form.Label>
              <Form.Control
                type="email"
                placeholder="Ingrese su correo"
                {...register('email', {
                  required: 'El email es requerido',
                  pattern: {
                    value: /^[A-z0-9._%+-]+@[A-z0-9.-]+\.[A-z]{2,4}$/,
                    message: 'El email no es valido',
                  },
                })}
              />
              <small className="text-danger">
                {errors?.email && errors.email.message}
              </small>
            </Form.Group>

            <Form.Group className="mb-3" controlId="resetPassword">
              <Form.Label>Nueva contrasena</Form.Label>
              <Form.Control
                type="password"
                placeholder="Minimo 8 caracteres"
                {...register('password', {
                  required: 'La contrasena es requerida',
                  minLength: { value: 8, message: 'La contrasena debe tener al menos 8 caracteres' },
                })}
              />
              <small className="text-danger">
                {errors?.password && errors.password.message}
              </small>
            </Form.Group>

            <Form.Group className="mb-3" controlId="resetPasswordConfirm">
              <Form.Label>Confirmar contrasena</Form.Label>
              <Form.Control
                type="password"
                placeholder="Repita su contrasena"
                {...register('password_confirmation', {
                  required: 'Debe confirmar la contrasena',
                  validate: (value) => value === password || 'Las contrasenas no coinciden',
                })}
              />
              <small className="text-danger">
                {errors?.password_confirmation && errors.password_confirmation.message}
              </small>
            </Form.Group>

            <div className="d-grid mb-3">
              <Button variant="primary" type="submit" disabled={isSubmitting}>
                {isSubmitting ? (
                  <span className="d-inline-flex align-items-center gap-2">
                    <Spinner animation="border" size="sm" /> Restableciendo...
                  </span>
                ) : 'Restablecer contrasena'}
              </Button>
            </div>

            <p className="text-center">
              <Link to="/iniciar-sesion" className="text-decoration-none">
                Volver a iniciar sesion
              </Link>
            </p>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default ResetPasswordPage;
